var exports = {
  "kL": "x804f0401--a8d25f--container",
  "Qs": "x804f0401--a8d25f--content",
  "wx": "x804f0401--a8d25f--header",
  "XI": "x804f0401--a8d25f--action",
};

module.exports = exports;
